import { useQuery } from "@apollo/client";
import { useLocale } from "next-intl";
import { EventsQuery } from "../queries/eventsQuery";

const useEventsBySegment = ({ segment, limit = 6 }) => {
  const locale = useLocale();
  let variables: any = { locale, limit, filter: {} };

  if (segment) variables.filter["segment"] = segment;
  const { data, loading, error, ...rest } = useQuery(EventsQuery, {
    variables,
    skip: !segment,
  });

  return {
    events: data?.academyModel || [],
    loading,
    error,
    ...rest,
  };
};

export default useEventsBySegment;
